import style from './News.module.css'
import classNames from 'classnames/bind'
import TimeAgo from './TimeAgo'
import { useState } from 'react'
// import useTranslation from 'next-translate/useTranslation'

export default function News ({ link, media, title, desc, date }) {
  // const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const [image, setImage] = useState(media?.thumbnail || media?.content)

  const external = new URL(link).hostname !== 'www.silverbullion.com.sg'
  const source = new URL(link).hostname.replace(/^www\./i, '')

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={link} target='_blank' rel='noopener' className={c('news')}>
      {image && <img src={external ? image : `/_next/image?url=${encodeURIComponent(image)}&w=384&q=75`} alt={title} onError={() => setImage('/images/news.jpg')} />}
      {date && <TimeAgo className={c('datetime')} date={new Date(date)} options={{ month: 'long' }} />}
      <h4>{title}</h4>
      {source && URL && <span className={c('source')}>{source}</span>}
      {desc && <p dangerouslySetInnerHTML={{ __html: desc.replace(/<[^>]+>/gs, '') }} />}
    </a>
  )
}
